import { render, staticRenderFns } from "./DsgvoDialog.vue?vue&type=template&id=249db64c&scoped=true"
import script from "./DsgvoDialog.vue?vue&type=script&lang=js"
export * from "./DsgvoDialog.vue?vue&type=script&lang=js"
import style0 from "./DsgvoDialog.vue?vue&type=style&index=0&id=249db64c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249db64c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Filati\\filatiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('249db64c')) {
      api.createRecord('249db64c', component.options)
    } else {
      api.reload('249db64c', component.options)
    }
    module.hot.accept("./DsgvoDialog.vue?vue&type=template&id=249db64c&scoped=true", function () {
      api.rerender('249db64c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/dialogs/DsgvoDialog.vue"
export default component.exports